import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useParents } from '../context/ParentsProvider';
import { useGiftees } from '../context/GifteesProvider';
import { useAuthentication } from '../context/AuthenticationProvider';
import { Giftee } from '../types/Giftee';
import { useShoppingCart } from '../context/ShoppingCartProvider';

const ScWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ScHeader = styled.h2`
  text-align: center;
`;

const ScText = styled.h5`
  text-align: center;
`;

export const ThankYou = () => {
  const { parents } = useParents();
  const { giftees } = useGiftees();
  const { user } = useAuthentication();
  const { updateCart } = useShoppingCart();

  useEffect(() => {
    updateCart();
  }, [updateCart]);

  return (
    <ScWrapper className="babys-page-padding">
      <ScHeader className="babys-cursive">Obrigado!</ScHeader>
      <ScText>
        {parents.join(' e ')} {parents.length === 0 ? 'agradece' : 'agradecem'}{' '}
        ao presente que{' '}
        {user?.names.length === 1 ? 'você escolheu' : 'vocês escolheram'} para{' '}
        {Giftee.joinGiftees(giftees, 'e')}.
      </ScText>
    </ScWrapper>
  );
};
